import OrganizationSpecific from "@/views/settings/organization";
import Clients from "@/views/clients";
import ContactDirectory from "@/views/clients/contact_persons";
import ClientDetails from "@/views/clients/_clientSlug";
import Designation from "@/views/settings/designation";
import RolesAndPermissions from "@/views/settings/roles_and_permissions";
import CommunicationMediumSetting from "@/views/settings/communication_mediums";
import ClientSourceSetting from "@/views/settings/client_source";
import IndustrySetting from "@/views/settings/industry";
import ClientValue from "@/views/reports/ClientValue";
import ClientFollowUp from "@/views/reports/ClientFollowUp";
import SalesStage from "@/views/reports/SalesStage";
import ActivityLog from "@/views/reports/ActivityLog";
import Industry from "@/views/reports/Industry";
import CRMUsers from "@/views/settings/crm-users";
import DepartmentAndTeams from "@/views/settings/department-and-teams";
import Documents from "@/views/settings/documents";
import ActivityLogs from "@/views/activity_logs";
import Overview from "@/views/overview";
import ClientAction from "@/views/clients/client_action";

const routes = [
  {
    path: "/",
    redirect: {
      name: "overview"
    }
  },
  {
    path: "/overview",
    name: "overview",
    component: Overview
  },
  {
    path: "/client-action",
    name: "client-action",
    component: ClientAction
  },
  {
    path: "/activity-logs",
    name: "activity-logs",
    component: ActivityLogs
  },
  {
    path: "/settings/organization",
    name: "settings-organization",
    component: OrganizationSpecific,
    meta: {
      auth: true,
      permissions: [
        "can_administer_organization_data",
        "can_make_activity_logs"
      ]
    }
  },
  {
    path: "/clients",
    name: "clients",
    component: Clients,
    meta: {
      auth: true,
      permissions: ["can_view_client"]
    }
  },
  {
    path: "/contact-persons",
    name: "contact-persons",
    component: ContactDirectory,
    meta: {
      auth: true,
      permissions: ["can_view_contact_persons", "can_modify_contact_persons"]
    }
  },
  {
    path: "/clients/:clientSlug",
    name: "clients-clientslug",
    component: ClientDetails
  },
  {
    path: "/settings/designation",
    name: "settings-designation",
    component: Designation,
    meta: {
      auth: true,
      permissions: [
        "can_administer_organization_data",
        "can_make_activity_logs",
        'can_view_client_designation'
      ]
    }
  },
  {
    path: "/settings/communication-mediums",
    name: "settings-communication-mediums",
    component: CommunicationMediumSetting,
    meta: {
      auth: true,
      permissions: [
        "can_administer_organization_data",
        "can_make_activity_logs",
        'client_mediums'
      ]
    }
  },
  {
    path: "/settings/client-source",
    name: "settings-client-source",
    component: ClientSourceSetting,
    meta: {
      auth: true,
      permissions: [
        "can_view_client_source",
        "can_make_client_source",
        "can_modify_client_source",
        'client_source'
      ]
    }
  },
  {
    path: "/settings/roles-and-permissions",
    name: "settings-roles-and-permissions",
    component: RolesAndPermissions,
    meta: {
      auth: true,
      permissions: ['can_view_roles_and_permissions']
    }
  },
  {
    path: "/settings/industry",
    name: "settings-industry",
    component: IndustrySetting,
    meta: {
      auth: true,
      permissions: ["can_administer_organization_data", "can_modify_client", "can_view_industry"]
    }
  },
  {
    path: "/settings/crm-users",
    name: "settings-crm-users",
    component: CRMUsers,
    meta: {
      auth: true,
      permissions: [
        'can_view_crm_users'
      ]
    }
  },
  {
    path: "/settings/department-and-teams",
    name: "settings-department-and-teams",
    component: DepartmentAndTeams,
    meta: {
      auth: true,
      permissions: [
        "can_view_divisions",
        "can_make_divisions",
        "can_modify_divisions"
      ]
    }
  },
  {
    path: "/settings/documents",
    name: "settings-documents",
    component: Documents
  },
  {
    path: "/report/client-value",
    name: "report-client-value",
    component: ClientValue,
    meta: {
      auth: true,
      permissions: ["can_view_report"]
    }
  },
  {
    path: "/report/client-follow-up",
    name: "report-client-follow-up",
    component: ClientFollowUp,
    meta: {
      auth: true,
      permissions: ["can_view_report", "can_view_client_follow_up"]
    }
  },
  {
    path: "/report/sales-stage",
    name: "report-sales-stage",
    component: SalesStage,
    meta: {
      auth: true,
      permissions: [
        "can_administer_organization_data",
        "can_make_activity_logs"
      ]
    }
  },
  {
    path: "/report/activity-log",
    name: "report-activity-log",
    component: ActivityLog,
    meta: {
      auth: true,
      permissions: ["can_view_activity_logs", "can_make_activity_logs"]
    }
  },
  {
    path: "/report/industry",
    name: "report-industry",
    component: Industry,
    meta: {
      auth: true,
      permissions: ["can_view_report", 'can_view_industry']
    }
  }
];

export default routes;
